import React from "react";
import ReactDOM from "react-dom";
import "src/assets/scss/index.scss";
import Root from "./apps";

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById("root")
);
